import * as React from "react";

export function useOnMount(onMount: () => any) {
  const onMountCallback = React.useCallback(onMount, []); // eslint-disable-line react-hooks/exhaustive-deps
  React.useEffect(onMountCallback, [onMountCallback]);
}
